import { render, staticRenderFns } from "./homePage.vue?vue&type=template&id=2f8d6620&scoped=true"
import script from "./homePage.vue?vue&type=script&lang=js"
export * from "./homePage.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/homepage.css?vue&type=style&index=0&id=2f8d6620&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8d6620",
  null
  
)

export default component.exports